import React from 'react';
import { Helmet } from 'react-helmet';
import { HeroSection } from '@/components/caretrack/HeroSection';
import { SpecialtiesSection } from '@/components/caretrack/SpecialtiesSection';
import { WhySpecialtiesSection } from '@/components/caretrack/WhySpecialtiesSection';
import { InteractionSection } from '@/components/caretrack/InteractionSection';
import { PlatformBenefitsSection } from '@/components/caretrack/PlatformBenefitsSection';
import { StatsSection } from '@/components/caretrack/StatsSection';
import { CTASection } from '@/components/caretrack/CTASection';
import { caretrackSchema } from '@/schemas/caretrack-schema';

const CareTrack = () => {
  return (
    <>
      <Helmet>
        <title>CareTrackAI - Advanced Post-Surgical Care Monitoring Platform | Scienza Health</title>
        <meta name="description" content="Transform post-surgical care with AI-powered monitoring for cardiac and orthopedic recovery. Real-time tracking of physical and cognitive health metrics." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        <meta name="robots" content="index, follow" />
        <meta name="keywords" content="post-surgical care, patient monitoring, healthcare AI, cardiac recovery, orthopedic recovery, cognitive health" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="CareTrackAI - Advanced Post-Surgical Care Monitoring" />
        <meta property="og:description" content="Transform post-surgical care with AI-powered monitoring for cardiac and orthopedic recovery. Real-time tracking of physical and cognitive health metrics." />
        <meta property="og:image" content="https://scienzahealth.com/mcai_social_preview.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CareTrackAI - Advanced Post-Surgical Care Monitoring" />
        <meta name="twitter:description" content="Transform post-surgical care with AI-powered monitoring for cardiac and orthopedic recovery. Real-time tracking of physical and cognitive health metrics." />
        <meta name="twitter:image" content="https://scienzahealth.com/mcai_social_preview.png" />
        
        {/* Mobile optimization */}
        <meta name="theme-color" content="#8B5CF6" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        
        {/* Structured data */}
        <script type="application/ld+json">
          {JSON.stringify(caretrackSchema)}
        </script>
      </Helmet>
      <div className="min-h-screen">
        <HeroSection />
        <SpecialtiesSection />
        <WhySpecialtiesSection />
        <InteractionSection />
        <PlatformBenefitsSection />
        <StatsSection />
        <CTASection />
      </div>
    </>
  );
};

export default CareTrack;